import React, { useCallback, useContext, useEffect, useState } from "react";
import { Wallet2 } from 'lucide-react';
import { Separator } from "../../components/ui/separator";
import { CircleCheck, DollarSign, SquareArrowOutUpRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../components/ui/dialog";

import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from '../../components/ui/pagination';
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { Toggle } from "../../components/ui/toggle";
import { toast, Toaster } from "sonner";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { FiDownload } from "react-icons/fi";
import * as XLSX from "xlsx";

const chartData = [
  { month: "January", desktop: 186 },
  { month: "February", desktop: 305 },
  { month: "March", desktop: 237 },
  { month: "April", desktop: 73 },
  { month: "May", desktop: 209 },
  { month: "June", desktop: 214 },
];
const chartConfig = {
  desktop: {
    label: "Desktop",
    color: "#0a67f2",
  },
};

const chartConfig1 = {
  desktop: {
    label: "Desktop",
    color: "#fd2692",
  },
};

const ServiceProviderDetails = () => {
  const token = localStorage.getItem("adminToken");
  const [partner, setPartner] = useState([]);
  const [earnings, setEarnings] = useState({});

  const [status, setStatus] = useState(partner?.kyc?.status?.toLowerCase()); // Default status
  const { id } = useParams();

  const [data, setData] = useState([]);
  const [partnerData, setPartnerData] = useState({
    categories: [],
    subcategories: [],
    services: [],
  });
  const getPartnerDetails = async () => {
    try {
      const res = await axios.get(
        `https://wavetechservices.in/api/admin/partners/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("partner", res.data.partner);
      setData(res.data.partner);
      setStatus(res.data.partner?.kyc?.status)
    } catch (error) {
      console.error(error, "error");
    }
  };

  useEffect(() => {
    getPartnerDetails();
  }, []);

  const getBookingDetails = async () => {
    try {
      const res = await axios.get(
        `https://wavetechservices.in/api/admin/partners/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(res.data.partner, "partner");
      setPartner(res.data.partner);
    } catch (error) {
      console.error(error, "error");
    }
  };

  useEffect(() => {
    getBookingDetails();
  }, []);

  const [book, setBook] = useState([]);

  const getBookings = async () => {
    try {
      const res = await axios.get(`https://wavetechservices.in/api/admin/partners`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // console.log(res.data.partners, "book");
      setBook(res.data.partners);

      const filteredBookings = book.filter(
        (partner) => partner?.Profile._id === id
      );
      // console.log(filteredBookings, "filtered");
    } catch (error) {
      console.error(error, "error");
    }
  };

  const fetchPartnerEarnings = async () => {
    try {
      if (!partner._id) return
      console.log("partner._id : ", partner._id)
      const res = await axios.get(`https://wavetechservices.in/api/admin/partner/${partner._id}/earnings`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setEarnings(res.data)
    } catch (error) {
      console.error("Error fecthing partner Earnings : ", error)
    }
  }
  const [ParterWallet, setParterWallet] = useState({});

  const [openWalletDialog, setOpenWalletDialog] = useState(false);
  const [walletAmount, setWalletAmount] = useState("");
  const [walletDescription, setWalletDescription] = useState("");
  const [walletAction, setWalletAction] = useState(null);
  const [Transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTransaction = Transactions?.slice(indexOfFirstItem, indexOfLastItem);

  // Handle pagination clicks
  const totalPages = Math.ceil(Transactions?.length / itemsPerPage);
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const maxVisiblePages = 5;
  const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);


  const getWallet = async () => {
    try {
      if (!id) return;
      const res = await axios.get(
        `https://wavetechservices.in/api/admin/adminwallets/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(res.data.data, "wallet details");

      setParterWallet(res.data.data);
      setTransactions(res.data.data?.transactions?.reverse() || []);
    } catch (error) {
      console.log(error, "error");
      toast.error("Failed to fetch partner wallet details");
    }
  };

  const handleWalletAction = async () => {
    if (!walletAmount || isNaN(walletAmount) || Number(walletAmount) <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }

    try {
      const response = await axios.put(
        `https://wavetechservices.in/api/admin/partner/addwallets`,
        {
          amount: Number(walletAmount),
          description: walletDescription,
          type: walletAction,
          partner: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        toast.success(`Successfully ${walletAction === 'credit' ? 'added' : 'deducted'} amount`);
        setWalletAmount("");
        setWalletDescription("");
        setWalletAction(null);
        getWallet(); // Refresh partner data to update wallet balance and transactions
      }
    } catch (error) {
      console.error("Error processing wallet action:", error);
      toast.error(error.response?.data?.message || "Operation failed");
    }
  };


  useEffect(() => {
    getBookings();
    getWallet();
  }, []);

  const endpoints = {
    categories: {
      url: "https://wavetechservices.in/api/admin/services/service-categories",
      ids: partner?.category || [],
    },
    subcategories: {
      url: "https://wavetechservices.in/api/user/subcategories",
      ids: partner?.subcategory || [],
    },
    services: {
      url: "https://wavetechservices.in/api/user/services",
      ids: partner?.service || [],
    },
  };

  const fetchData = useCallback(async () => {
    const results = {};

    await Promise.all(
      Object.entries(endpoints).map(async ([key, { url, ids }]) => {
        try {
          const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
          });

          results[key] = res.data.data.filter((item) =>
            ids.includes(item._id)
          );
        } catch (error) {
          console.error(`Error fetching ${key}:`, error);
          toast.error(`Failed to fetch ${key}`);
          results[key] = [];
        }
      })
    );

    setPartnerData(results);
  }, [token, partner]);




  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    fetchPartnerEarnings();
  }, [partner._id]);

  // console.log("status : " , status)
  // console.log("partner?.kyc?.status : " , partner?.kyc?.status)

  const toggleStatus = async () => {
    const newStatus = status?.toLowerCase() === "approved" ? "rejected" : "approved";
    try {
      const res = await axios.put(
        `https://wavetechservices.in/api/admin/partners/${partner._id}/status`,
        { status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("res : ", res)
      setStatus(newStatus);
      toast.success(`Provider Account ${newStatus?.toLowerCase()} successfully`);
    } catch (err) {
      console.error("Error:", err);
      toast.error("Failed to update status");
    }
  };

  const exportToExcel = () => {
    if (!partner || !Array.isArray(partner.bookings)) {
      console.error("Error: partner.bookings is not an array", partner);
      return;
    }

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(partner.bookings); // Export bookings data
    XLSX.utils.book_append_sheet(wb, ws, "Booking History");
    XLSX.writeFile(wb, "booking_history.xlsx");
  };

  if (!partner) {
    return <div className="flex items-center justify-center h-screen">
      <button
        disabled=""
        class="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold py-3 px-6 rounded-full shadow-lg flex items-center transition duration-300 transform hover:scale-105 active:scale-95"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="animate-spin h-5 w-5 mr-3 text-white"
        >
          <circle
            stroke-width="4"
            stroke="currentColor"
            r="10"
            cy="12"
            cx="12"
            class="opacity-25"
          ></circle>
          <path
            d="M4 12a8 8 0 018-8v8H4z"
            fill="currentColor"
            class="opacity-75"
          ></path>
        </svg>
        Loading...
      </button>
    </div>
  }

  return (
    <div className="p-3">
      <Toaster />

      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-medium">
          {partner?.profile?.name} - {partner._id}
        </h1>

        <div className="flex items-center gap-4"> {/* Reduced gap here */}
           <Dialog open={openWalletDialog} onOpenChange={setOpenWalletDialog}>
                      <DialogTrigger asChild>
                        <Button variant="outline" className="flex items-center gap-2">
                          <Wallet2 className="h-4 w-4" />
                          Wallet
                        </Button>
                      </DialogTrigger>
                      <DialogContent className="sm:max-w-[600px]">
                        <DialogHeader>
                          <DialogTitle>Wallet Management - {partner?.profile?.name}</DialogTitle>
                          <DialogDescription>
                            Manage wallet balance and view transaction history
                          </DialogDescription>
                        </DialogHeader>
                        <div className="grid gap-4 py-4">
                          <div className="bg-gray-100 p-4 rounded-md">
                            <h3 className="text-lg font-semibold">Current Balance: ₹{ParterWallet?.balance || 0}</h3>
                          </div>
                          <div className="grid grid-cols-1 gap-4">
                            <div className="grid grid-cols-4 items-center gap-4">
                              <Label htmlFor="wallet-amount" className="text-right">Amount</Label>
                              <Input
                                id="wallet-amount"
                                type="number"
                                value={walletAmount}
                                onChange={(e) => setWalletAmount(e.target.value)}
                                className="col-span-3"
                                placeholder="Enter amount"
                              />
                            </div>
                            <div className="grid grid-cols-4 items-center gap-4">
                              <Label htmlFor="wallet-description" className="text-right">Description</Label>
                              <Input
                                id="wallet-description"
                                value={walletDescription}
                                onChange={(e) => setWalletDescription(e.target.value)}
                                className="col-span-3"
                                placeholder="Enter description"
                              />
                            </div>
                            <div className="flex gap-2">
                              <Button
                                onClick={() => setWalletAction('credit')}
                                disabled={!walletAmount || !walletDescription}
                              >
                                Add Amount
                              </Button>
                              <Button
                                onClick={() => setWalletAction('debit')}
                                disabled={!walletAmount || !walletDescription}
                                variant="destructive"
                              >
                                Deduct Amount
                              </Button>
                            </div>
                          </div>
                          <Separator />
                          <h3 className="text-lg font-semibold">Transaction History</h3>
                          <div className="overflow-x-auto">
                            <Table>
                              <TableHeader>
                                <TableRow>
                                  <TableHead>Transaction ID</TableHead>
                                  <TableHead>Type</TableHead>
                                  <TableHead>Amount</TableHead>
                                  <TableHead>Balance</TableHead>
                                  <TableHead>Description</TableHead>
                                  <TableHead>Date</TableHead>
                                </TableRow>
                              </TableHeader>
                              <TableBody>
                                {currentTransaction?.length > 0 ? (
                                  currentTransaction.map((txn) => (
                                    <TableRow key={txn.transactionId}>
                                      <TableCell>{txn.transactionId}</TableCell>
                                      <TableCell className={txn.type === 'credit' ? 'text-green-600' : 'text-red-600'}>
                                        {txn.type.charAt(0).toUpperCase() + txn.type.slice(1)}
                                      </TableCell>
                                      <TableCell>₹{txn.amount}</TableCell>
                                      <TableCell>₹{txn.balance}</TableCell>
                                      <TableCell>{txn.description || '-'}</TableCell>
                                      <TableCell>{new Date(txn.createdAt).toLocaleString()}</TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={6} className="text-center py-4">
                                      No transactions found
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </div>
                          <Pagination className="mt-4">
                            <PaginationContent>
                              {currentPage > 1 && (
                                <PaginationItem>
                                  <PaginationPrevious onClick={() => handlePageChange(currentPage - 1)} />
                                </PaginationItem>
                              )}
          
                              {startPage > 1 && (
                                <>
                                  <PaginationItem>
                                    <PaginationLink onClick={() => handlePageChange(1)}>1</PaginationLink>
                                  </PaginationItem>
                                  {startPage > 2 && <PaginationItem><span>...</span></PaginationItem>}
                                </>
                              )}
          
                              {[...Array(endPage - startPage + 1)].map((_, index) => {
                                const pageNumber = startPage + index;
                                return (
                                  <PaginationItem key={pageNumber}>
                                    <PaginationLink
                                      isActive={pageNumber === currentPage}
                                      onClick={() => handlePageChange(pageNumber)}
                                    >
                                      {pageNumber}
                                    </PaginationLink>
                                  </PaginationItem>
                                );
                              })}
          
                              {endPage < totalPages && (
                                <>
                                  {endPage < totalPages - 1 && <PaginationItem><span>...</span></PaginationItem>}
                                  <PaginationItem>
                                    <PaginationLink onClick={() => handlePageChange(totalPages)}>{totalPages}</PaginationLink>
                                  </PaginationItem>
                                </>
                              )}
          
                              {currentPage < totalPages && (
                                <PaginationItem>
                                  <PaginationNext onClick={() => handlePageChange(currentPage + 1)} />
                                </PaginationItem>
                              )}
                            </PaginationContent>
                          </Pagination>
                        </div>
                        {walletAction && (
                          <div className="flex justify-end gap-2">
                            <Button variant="outline" onClick={() => setWalletAction(null)}>
                              Cancel
                            </Button>
                            <Button onClick={handleWalletAction}>
                              Confirm {walletAction === 'credit' ? 'Add' : 'Deduct'}
                            </Button>
                          </div>
                        )}
                      </DialogContent>
                    </Dialog>

          <button
            className="px-4 py-2 text-white rounded-md bg-black text-sm"
            onClick={toggleStatus}
          >
            {status === "approved" ? "Deactivate" : "Activate"}
          </button>
        </div>
      </div>

      <div>
        <fieldset className="border border-gray-300 rounded-md p-3 w-full ">
          <legend className="font-medium p-3">Personal Information</legend>
          <div className="flex gap-10 lg:flex-between flex-col lg:flex-row">
            <div className="flex flex-row space-y-2 items-center gap-40">
              <img
                src={`${partner?.profilePicture}`}
                alt="avatar"
                className="rounded-full size-28 object-cover   mx-auto lg:mx-0"
              />
              <div className="flex flex-col">
                <div className="flex gap-3">
                  <label htmlFor="" className="w-16">
                    Name:
                  </label>
                  <h1 className="font-medium">{partner?.profile?.name}</h1>
                </div>
                <div className="flex gap-3">
                  <label htmlFor="" className="w-16">
                    Email:
                  </label>
                  <h1 className="font-medium">{partner?.profile?.email}</h1>
                </div>
                <div className="flex gap-3">
                  <label htmlFor="" className="w-16">
                    Phone:
                  </label>
                  <h1 className="font-medium">{partner?.phone}</h1>
                </div>
                <div className="flex gap-3">
                  <label htmlFor="" className="w-16">
                    Address:
                  </label>
                  <h1 className="font-medium">{partner?.profile?.address}</h1>
                </div>
              </div>

              <div className="flex items-center justify-end lg:justify-start mt-4 lg:mt-0">
                <Dialog>
                  <DialogTrigger asChild>
                    <Button
                      variant="outline"
                      className="flex items-center gap-2"
                    >
                      View Earnings & Transactions
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="max-w-4xl rounded-lg">
                    <DialogHeader>
                      <DialogTitle className="text-lg font-semibold">
                        <div className="flex items-center gap-2">
                          <span>Partner Earnings</span>
                        </div>
                      </DialogTitle>
                    </DialogHeader>
                    <div className="max-h-[70vh] overflow-y-auto p-4 space-y-6">
                      {/* Summary Section */}
                      <div className="bg-blue-50 p-4 rounded-lg">
                        <h3 className="font-semibold text-lg mb-2">Summary</h3>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                          <div className="bg-white p-3 rounded shadow">
                            <p className="text-sm text-gray-500">Total Earnings</p>
                            <p className="font-bold text-xl">₹{earnings?.totalEarnings}</p>
                          </div>
                          <div className="bg-white p-3 rounded shadow">
                            <p className="text-sm text-gray-500">Completed Jobs</p>
                            <p className="font-bold text-xl">{earnings?.transactions?.length}</p>
                          </div>
                          <div className="bg-white p-3 rounded shadow">
                            <p className="text-sm text-gray-500">Avg. Earnings</p>
                            <p className="font-bold text-xl">
                              ₹{Math.round(earnings?.totalEarnings / earnings?.transactions?.length)}
                            </p>
                          </div>
                          {/* <div className="bg-white p-3 rounded shadow">
                          <p className="text-sm text-gray-500">Commission Rate</p>
                          <p className="font-bold text-xl">
                            {earnings?.transactions[0]?.commissionPercentage || 0}%
                          </p>
                        </div> */}
                        </div>
                      </div>

                      {/* Transactions Table */}
                      <div>
                        <h3 className="font-semibold text-lg mb-3">Transaction History</h3>
                        <div className="overflow-x-auto">
                          <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                              <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                  Booking ID
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                  Customer
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                  Service
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                  Amount
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                  Earnings
                                </th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                  Date
                                </th>
                              </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                              {earnings?.transactions?.map((txn) => (
                                <tr key={txn.bookingId}>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {txn?.bookingId?.substring(0, 8)}...
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm font-medium text-gray-900">
                                      {txn?.user?.name}
                                    </div>
                                    <div className="text-sm text-gray-500">
                                      {txn?.user?.email}
                                    </div>
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {txn?.subService}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    ₹{txn?.totalAmount}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    <span className="text-green-600 font-medium">
                                      ₹{txn?.partnerEarnings}
                                    </span>
                                    <span className="block text-xs text-gray-400">
                                      (Commission: ₹{txn?.commissionAmount})
                                    </span>
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {new Date(txn?.completedAt).toLocaleDateString()}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </DialogContent>
                </Dialog>
              </div>
            </div>


          </div>
        </fieldset>
      </div>
      {/* <h1 className="text-2xl font-medium mb-5 mt-10">Provider Performance</h1>

      <div className="flex gap-5 flex-col lg:flex-row">
        <Card className="lg:w-[32%] w-full">
          <CardHeader>
            <CardTitle>Booking</CardTitle>
            <CardDescription>January - June 2024</CardDescription>
          </CardHeader>
          <CardContent>
            <ChartContainer config={chartConfig}>
              <BarChart accessibilityLayer data={chartData}>
                <CartesianGrid vertical={false} />
                <XAxis
                  dataKey="month"
                  tickLine={false}
                  tickMargin={10}
                  axisLine={false}
                  tickFormatter={(value) => value.slice(0, 3)}
                />
                <ChartTooltip
                  cursor={false}
                  content={<ChartTooltipContent hideLabel />}
                />
                <Bar dataKey="desktop" fill="var(--color-desktop)" radius={8} />
              </BarChart>
            </ChartContainer>
          </CardContent>
          <CardFooter className="flex-col items-start gap-2 text-sm">
            <div className="flex gap-2 font-medium leading-none">
              Trending up by 5.2% this month <TrendingUp className="h-4 w-4" />
            </div>
            <div className="leading-none text-muted-foreground">
              Showing total visitors for the last 6 months
            </div>
          </CardFooter>
        </Card>

        <Card className="lg:w-[32%] w-full">
          <CardHeader>
            <CardTitle>Earning</CardTitle>
            <CardDescription>January - June 2024</CardDescription>
          </CardHeader>
          <CardContent>
            <ChartContainer config={chartConfig1}>
              <BarChart accessibilityLayer data={chartData}>
                <CartesianGrid vertical={false} />
                <XAxis
                  dataKey="month"
                  tickLine={false}
                  tickMargin={10}
                  axisLine={false}
                  tickFormatter={(value) => value.slice(0, 3)}
                />
                <ChartTooltip
                  cursor={false}
                  content={<ChartTooltipContent hideLabel />}
                />
                <Bar dataKey="desktop" fill="var(--color-desktop)" radius={8} />
              </BarChart>
            </ChartContainer>
          </CardContent>
          <CardFooter className="flex-col items-start gap-2 text-sm">
            <div className="flex gap-2 font-medium leading-none">
              Trending up by 5.2% this month <TrendingUp className="h-4 w-4" />
            </div>
            <div className="leading-none text-muted-foreground">
              Showing total visitors for the last 6 months
            </div>
          </CardFooter>
        </Card>

        <Card className="flex flex-col">
          <CardHeader className="items-center pb-0">
            <CardTitle>Provider Performance</CardTitle>
            <CardDescription>January - June 2024</CardDescription>
          </CardHeader>
          <CardContent className="flex-1 pb-0">
            <ChartContainer
              config={chartConfig2}
              className="mx-auto aspect-square max-h-[250px]"
            >
              <PieChart>
                <ChartTooltip
                  cursor={false}
                  content={<ChartTooltipContent hideLabel />}
                />
                <Pie
                  data={chartData2}
                  dataKey="visitors"
                  nameKey="browser"
                  innerRadius={60}
                  strokeWidth={5}
                >
                  <Label
                    content={({ viewBox }) => {
                      if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                        return (
                          <text
                            x={viewBox.cx}
                            y={viewBox.cy}
                            textAnchor="middle"
                            dominantBaseline="middle"
                          >
                            <tspan
                              x={viewBox.cx}
                              y={viewBox.cy}
                              className="fill-foreground text-3xl font-bold"
                            >
                              {partner?.bookings?.length}
                            </tspan>
                            <tspan
                              x={viewBox.cx}
                              y={(viewBox.cy || 0) + 24}
                              className="fill-muted-foreground"
                            >
                              Booking
                            </tspan>
                          </text>
                        );
                      }
                    }}
                  />
                </Pie>
              </PieChart>
            </ChartContainer>
          </CardContent>
          <CardFooter className="flex-col gap-2 text-sm">
            <div className="flex items-center gap-2 font-medium leading-none">
              Trending up by 5.2% this month <TrendingUp className="h-4 w-4" />
            </div>
            <div className="leading-none text-muted-foreground">
              Showing total visitors for the last 6 months
            </div>
          </CardFooter>
        </Card>
      </div> */}


      <Card className="lg:col-span-1 mt-10">
        <CardHeader>
          <CardTitle>Service Information</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {/* Categories Section */}
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-2">Categories</h3>
              <div className="flex flex-wrap gap-2">
                {partnerData.categories.length > 0 ? (
                  partnerData.categories.map((c) => (
                    <span
                      key={c._id}
                      className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10"
                    >
                      {c.name}
                    </span>
                  ))
                ) : (
                  <p className="text-sm text-gray-400">No categories selected</p>
                )}
              </div>
            </div>

            {/* Subcategories Section */}
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-2">Subcategories</h3>
              <div className="flex flex-wrap gap-2">
                {partnerData.subcategories.length > 0 ? (
                  partnerData.subcategories.map((s) => (
                    <span
                      key={s._id}
                      className="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10"
                    >
                      {s.name}
                    </span>
                  ))
                ) : (
                  <p className="text-sm text-gray-400">No subcategories selected</p>
                )}
              </div>
            </div>

            {/* Services Section */}
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-2">Services</h3>
              <div className="flex flex-wrap gap-2">
                {partnerData.services.length > 0 ? (
                  partnerData.services.map((s) => (
                    <span
                      key={s._id}
                      className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-700/10"
                    >
                      {s.name}
                    </span>
                  ))
                ) : (
                  <p className="text-sm text-gray-400">No services selected</p>
                )}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-medium mb-5 mt-10">
          Booking Details- {partner?.bookings?.length}
        </h1>
        <Button className="flex items-center gap-2" onClick={exportToExcel}>
          <FiDownload /> Export Excel
        </Button>
      </div>

      <div>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[100px]">Sl No</TableHead>
              <TableHead className="w-[100px]">Service</TableHead>
              <TableHead>User</TableHead>
              <TableHead> Email</TableHead>
              <TableHead> Phone</TableHead>
              <TableHead className="text-right">Location</TableHead>
              <TableHead>Scheduled Date & Time</TableHead>
              <TableHead className="text-right">Amount</TableHead>
              <TableHead className="text-right">Partner Earning</TableHead>
              <TableHead className="text-right">Admin Earning</TableHead>
              <TableHead className="text-right">Payment Mode</TableHead>
              <TableHead className="text-right">Booking Status</TableHead>

              <TableHead className="text-right">Booking Updated At</TableHead>
              <TableHead className="text-right">Booking Photo</TableHead>
              <TableHead className="text-right">Booking Video</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {partner?.bookings?.map((booking, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{index + 1}</TableCell>
                <TableCell className="font-medium">
                  {booking?.subService?.name}
                </TableCell>
                <TableCell className="font-medium">
                  {booking?.user?.name}
                </TableCell>
                <TableCell className="font-medium">
                  {booking?.user?.email}
                </TableCell>
                <TableCell className="font-medium">
                  {booking?.user?.phone}
                </TableCell>
                <TableCell className="font-medium">
                  {booking?.location?.address}
                </TableCell>
                <TableCell className="truncate">
                  {booking?.createdAt
                    ? new Intl.DateTimeFormat("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true, // For 12-hour format (AM/PM)
                    }).format(new Date(booking.createdAt))
                    : "N/A"}
                </TableCell>
                <TableCell className="font-medium">{booking?.amount}</TableCell>
                <TableCell className="font-medium">
                </TableCell>
                <TableCell className="font-medium">
                </TableCell>
                <TableCell className="font-medium">
                  {booking?.paymentMode}
                </TableCell>
                <TableCell className="font-medium">{booking?.status}</TableCell>
                <TableCell className="truncate">
                  {booking?.updatedAt
                    ? new Intl.DateTimeFormat("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                      hour12: true, // For 12-hour format (AM/PM)
                    }).format(new Date(booking.updatedAt))
                    : "N/A"}
                </TableCell>
                <TableCell className="font-medium">
                  {booking.photos.map((photo, index) => (
                    <img
                      key={index}
                      src={`${photo}`}
                      alt="booking"
                      className="w-20 h-20"
                    />
                  ))}
                </TableCell>

                <TableCell className="font-medium">
                  <Dialog>
                    <DialogTrigger>View Video</DialogTrigger>
                    <DialogContent>
                      <DialogHeader>
                        <DialogTitle>Added Video</DialogTitle>

                        <DialogDescription>
                          <div className="flex flex-wrap gap-3 my-3">
                            {booking?.videos?.map((video, index) => (
                              <video
                                className="w-full h-[600px] object-cover"
                                controls
                              >
                                <source
                                  className="w-20 h-20"
                                  key={index}
                                  src={`${video}`}
                                  type="video/mp4"
                                />
                              </video>
                            ))}
                          </div>
                        </DialogDescription>
                      </DialogHeader>
                    </DialogContent>
                  </Dialog>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default ServiceProviderDetails;
